import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=0915aee2&scoped=true"
import script from "./HowTo.vue?vue&type=script&lang=js"
export * from "./HowTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915aee2",
  null
  
)

export default component.exports